// Color scheme used in our analytics graphs

const colors = [
  "#f94144",
  "#0071ce",
  "#f3722c",
  "#8093f1",
  "#577590",
  "#2d3142",
  "#f9c74f",
  "#90be6d",
  "#43aa8b",
  "#4d908e",
  "#277da1",
  "#ff8fab",
  "#aacc00",
  "#662e9b",
];

export default colors;
